import React from "react"
import CustomButton from "components/Atoms/CustomButton"
const CalloutButton = ({
  path,
  index,
  listLength,
  disabled,
  newObject,
  onAdd,
  onRemove,
}) => {
  return (
    <>
      {index === listLength - 1 ? (
        <CustomButton
          icon="plus"
          intent="success"
          className="absolute z-[3]"
          relative={false}
          minimal={true}
          disabled={disabled}
          onClick={() => onAdd(path, newObject)}
        />
      ) : (
        <CustomButton
          icon="minus"
          intent="danger"
          className="absolute z-[3]"
          relative={false}
          minimal={true}
          disabled={listLength > 0 ? false : disabled}
          onClick={e => onRemove(path, index)}
        />
      )}
    </>
  )
}

export default CalloutButton
